let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
return new bootstrap.Popover(popoverTriggerEl)
});

import { Tooltip } from "bootstrap";
new Tooltip(document.body, {
    selector: "[data-tooltip='tooltip']",
});

/**
 * Nav toggle
 */
const navToggle = document.getElementsByClassName('main-toggle')[0];
const mainNav = document.getElementsByClassName('main-nav')[0];

const navToggleClick = () => {
    mainNav.classList.toggle('active');
}

navToggle.addEventListener('click', navToggleClick);
